export const LOAD_PROFILE = "settings/LOAD_PROFILE";
export const UPDATED_PROFILE = "settings/UPDATED_PROFILE";
export const UPDATING_PROFILE = "settings/UPDATING_PROFILE";
export const UPDATING_PARTICIPATING_PROGRAM =
  "settings/UPDATING_PARTICIPATING_PROGRAM";
export const LOAD_ASSIGNED_PATIENTS = "settings/LOAD_ASSIGNED_PATIENTS";
export const LOAD_PROGRAM_CONFIGS = "settings/LOAD_PROGRAM_CONFIGS";
